var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { styled } from 'styled-components';
import { Check } from '@hn-ui/icons';
import { Tooltip } from '../../ActivityStreamDashboard/Tooltip';
var ScCheckIcon = styled(Check).withConfig({ displayName: "ScCheckIcon", componentId: "sc-j1habi" })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Square = styled.div.withConfig({ displayName: "Square", componentId: "sc-1q97zlh" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: 24px;\n  height: 24px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 6px;\n  margin-right: 16px;\n"], ["\n  display: flex;\n  width: 24px;\n  height: 24px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 6px;\n  margin-right: 16px;\n"])));
var LabelText = styled.label.withConfig({ displayName: "LabelText", componentId: "sc-1mevp34" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n  cursor: inherit;\n  white-space: nowrap;\n"], ["\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n  cursor: inherit;\n  white-space: nowrap;\n"])));
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-18rbdvz" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: ", ";\n  pointer-events: ", ";\n\n  ", " {\n    background: ", ";\n    border: 2px solid\n      ", ";\n  }\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: ", ";\n  pointer-events: ", ";\n\n  ", " {\n    background: ", ";\n    border: 2px solid\n      ", ";\n  }\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    color: ", ";\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return !disabled && 'pointer';
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && 'none';
}, Square, function (_a) {
    var checked = _a.checked, theme = _a.theme;
    return checked ? theme.colors.primary : theme.colors.white;
}, function (_a) {
    var checked = _a.checked, theme = _a.theme;
    return (checked ? theme.colors.primary : '#d7dde4');
}, ScCheckIcon, function (_a) {
    var checked = _a.checked;
    return (checked ? 'block' : 'none');
}, LabelText, function (_a) {
    var theme = _a.theme;
    return theme.colors.blackText;
});
var CheckBox = function (_a) {
    var tooltipContent = _a.tooltipContent, _b = _a.tooltipDisabled, tooltipDisabled = _b === void 0 ? true : _b, label = _a.label, disabled = _a.disabled, _c = _a.checked, checked = _c === void 0 ? false : _c, onChecked = _a.onChecked, rest = __rest(_a, ["tooltipContent", "tooltipDisabled", "label", "disabled", "checked", "onChecked"]);
    var _d = useState(checked), isToggled = _d[0], toggle = _d[1];
    var handleOnChecked = useCallback(function () {
        if (disabled)
            return;
        toggle(!isToggled);
        if (onChecked)
            onChecked(isToggled);
    }, [onChecked, disabled, isToggled]);
    return (_jsxs(Container, __assign({ checked: isToggled, disabled: disabled }, rest, { role: 'checkbox', onClick: handleOnChecked }, { children: [_jsx(Tooltip, __assign({ content: tooltipContent, disabled: tooltipDisabled }, { children: _jsx(Square, { children: _jsx(ScCheckIcon, {}, void 0) }, void 0) }), void 0), _jsx(LabelText, { children: label }, void 0)] }), void 0));
};
export { CheckBox };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
